import { BahnhofsdatenFilter } from "./BahnhofsdatenFilter";

export default function Bahnhofsdaten({vvInstance, statusInstance, zvInstance, bhfdInstance}) {
    return (
        <div>
            <h1>Bahnhofsdaten</h1>
            <BahnhofsdatenFilter vvInstance={vvInstance} statusInstance={statusInstance} zvInstance={zvInstance} bhfdInstance={bhfdInstance}/>
        </div>

    )
}